module.exports = __webpack_public_path__ + "img/510.5de4bcef.png";